import { CfgReferencePathHelper, DtoCataloguePermission } from "@configura/web-api";
import React, { ChangeEventHandler, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

export function useFormInput(
	id: string,
	initialValue: string
): {
	id: string;
	name: string;
	onChange: ChangeEventHandler<HTMLSelectElement>;
	value: string;
} {
	const [value, setValue] = useState(initialValue);

	function handleChange(
		e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
	) {
		setValue(e.currentTarget.value);
	}

	return {
		id,
		name: id,
		onChange: handleChange,
		value,
	};
}

const strictPrdCatVersionInUrls = true;
const DEFAULT_LANG = "en-US";

type CatalogueCardProps = DtoCataloguePermission & {
	browsingRootUrl: string;
	showEnterprise?: boolean;
};

export const CatalogueCard: React.FC<CatalogueCardProps> = (props) => {
	const {
		browsingRootUrl,
		cid,
		enterprise,
		prdCat,
		prdCatVersion,
		priceLists,
		showEnterprise,
		vendors,
	} = props;

	const vendor = useFormInput("vendor", vendors !== undefined ? vendors[0] : "-");
	const priceList = useFormInput("pricelist", priceLists !== undefined ? priceLists[0] : "-");

	const path = CfgReferencePathHelper.getCataloguePath(browsingRootUrl, {
		cid,
		lang: DEFAULT_LANG,
		enterprise,
		prdCat,
		prdCatVersion: strictPrdCatVersionInUrls ? prdCatVersion : "-",
		vendor: vendor.value,
		priceList: priceList.value,
	});

	return (
		<li key={path}>
			<div className={styles.card}>
				<div className={styles.cardContent}>
					<span className={styles.cardDesignHeader}>PRDCAT</span>
					<h2 className={styles.cardHeader}>{prdCat}</h2>
					{showEnterprise && (
						<dl className={styles.dl}>
							<div>
								<dt className={styles.cardDesignHeader}>Enterprise</dt>
								<dd className={styles.cardInfoText}>{enterprise}</dd>
							</div>
						</dl>
					)}
					<div className={styles.selectContainer}>
						<div className={styles.selectBox}>
							<span className={styles.cardDesignHeader}>Vendor</span>
							{vendors === undefined ? (
								<p className={styles.cardInfoText}>No vendors</p>
							) : (
								<select {...vendor}>
									{vendors.map((v) => (
										<option key={v} value={v}>
											{v}
										</option>
									))}
								</select>
							)}
						</div>
						<div className={styles.selectBox}>
							<span className={styles.cardDesignHeader}>Pricelist</span>
							{priceLists === undefined ? (
								<p className={styles.cardInfoText}>No pricelist</p>
							) : (
								<select {...priceList}>
									{priceLists.map((p) => (
										<option key={p} value={p}>
											{p}
										</option>
									))}
								</select>
							)}
						</div>
					</div>
				</div>
				<Link className={styles.cardLink} to={path}>
					Access
				</Link>
			</div>
		</li>
	);
};
